import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';

import { TenantService } from '../../services/tenant.service';
import { RentalService } from '../../services/rental.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-admin-tenants',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './admin-tenants.component.html'
})
export class AdminTenantsComponent implements OnInit {

  tenants: any[] = [];
  rentals: any[] = [];
  users: any[] = [];

  form!: FormGroup;

  isTenantModalOpen = false;
  isLinkUserModalOpen = false;

  editingTenantId: string | null = null;
  linkingTenant: any | null = null;
  selectedUserId: string | null = null;
linkUserForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private tenantService: TenantService,
    private rentalService: RentalService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.loadTenants();
    this.loadRentals();
    this.loadUsers();
    this.linkUserForm = this.fb.group({
      userId: ['', Validators.required]
    });

  }

  private buildForm() {
    this.form = this.fb.group({
      fullName: ['', Validators.required],
      email: [''],
      phone: [''],
      rentalId: ['', Validators.required],
      rentalAddress: [{ value: '', disabled: true }],
      monthlyRent: [0, Validators.required],
      startDate: ['', Validators.required],
      notes: ['']
    });
  }

  private loadTenants() {
    this.tenantService.getTenants().subscribe(t => this.tenants = t);
  }

  private loadRentals() {
    this.rentalService.getRentals().subscribe(r => this.rentals = r);
  }

  private loadUsers() {
    this.userService.getUsers().subscribe(u => this.users = u);
  }

  /* =====================
     TENANT CRUD
     ===================== */

  openCreateTenant() {
    this.editingTenantId = null;
    this.form.reset();
    this.isTenantModalOpen = true;
  }

  openEditTenant(tenant: any) {
    this.editingTenantId = tenant.id;
    this.form.patchValue(tenant);
    this.isTenantModalOpen = true;
  }

  closeTenantModal() {
    this.isTenantModalOpen = false;
    this.form.reset();
  }

  onRentalChange(rentalId: string) {
    const rental = this.rentals.find(r => r.id === rentalId);
    if (!rental) return;

    this.form.patchValue({
      rentalAddress: rental.address,
      monthlyRent: rental.price
    });
  }

  async saveTenant() {
    if (this.form.invalid) return;

    const payload = {
      ...this.form.getRawValue(),
      status: 'active'
    };

    if (this.editingTenantId) {
      await this.tenantService.updateTenant(this.editingTenantId, payload);
    } else {
      await this.tenantService.createTenant(payload);
    }

    this.closeTenantModal();
    this.loadTenants();
  }

  async archiveTenant(id: string) {
    await this.tenantService.updateTenant(id, { status: 'archived' });
    this.loadTenants();
  }

  /* =====================
     USER LINKING
     ===================== */

  openLinkUser(tenant: any) {
    this.linkingTenant = tenant;
    this.linkUserForm.reset();
    this.isLinkUserModalOpen = true;
  }

  closeLinkUser() {
    this.linkingTenant = null;
    this.selectedUserId = null;
    this.isLinkUserModalOpen = false;
  }

  async confirmLinkUser() {
    if (this.linkUserForm.invalid || !this.linkingTenant) return;

    const userId = this.linkUserForm.value.userId;

    await this.tenantService.linkUser(this.linkingTenant.id, userId);
    await this.userService.assignTenant(userId, this.linkingTenant.id);

    this.closeLinkUser();
    this.loadTenants();
  }

}
